<!--托售设置-->
<template>
    <el-drawer
        title="托售设置"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <div v-if="itemData">
                <el-card header="参考信息" class="card1 MT20">
					<div class="item">
					    <label class="color-info">票品名称：</label><b>{{itemData.ticketName}}</b>
					</div>
					<div class="item">
					    <label class="color-info">托售数据：</label>
						<b>
							总托售订单：<span class="color-danger">{{itemData.consignTotalNum}}</span> 
							当前托售订单：<span class="color-danger">{{itemData.consigningNum}}</span>
							成功托售订单：<span class="color-danger">{{itemData.consignSuccessNum}}</span>
							托售成功率：<span class="color-danger">{{itemData.consignRate}}</span>
							<el-link class="link color-blue" target="_blank" :href="`/activityManage/order/list?searchType=1&searchValue=${activityId}&consignStatus`" >查看托售订单</el-link>
						</b>
					</div>
					<div class="item">
					    <label class="color-info">销售时间：</label><b class="color-blue">{{itemData.startTime}} 至 {{itemData.endTime}}</b>
					</div>
					<div class="item" v-if="itemTime">
					    <label class="color-info">演出开演时间：</label><b class="color-blue">{{itemTime}}</b>
					</div>
					<div class="item">
					    <label class="color-info">托售自动结束时间：</label><b class="color-blue">{{itemData.consignEndTime}}</b>
					</div>
					<div class="item">
					    <label class="color-info">账号限购：</label><b>{{itemData.accountLimitNum == 0 ? '不限购' : itemData.accountLimitNum}}</b>
					</div>
                </el-card>
			</div>
			<div class="formBox" v-if="formDatas">
				<el-form 
					:model="formDatas"					
					ref="formDatas"
					label-position="top"
					class="MT10">
					<el-form-item prop="status">
						<span slot="label">托售开关: </span>
						<el-radio-group v-model="formDatas.status">
							<el-radio :label="1" :disabled="itemData && itemData.canOpenConsign == 0">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>						
					</el-form-item>
					<el-form-item prop="isAutoOpenConsign">
						<span slot="label">系统自动开启开关: <span class="color-warning">（当票品开启候补且演出下所有票品售罄时自动开启托售）</span></span>
						<el-radio-group v-model="formDatas.isAutoOpenConsign">
							<el-radio :label="1">开启</el-radio>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>						
					</el-form-item>
					<el-form-item>
						<span slot="label">托售服务费:</span>
						<el-input-number style="width:95%" v-model="formDatas.consignServiceFee" :precision="1" controls-position="right" :min="0.1" :max="11" size="medium"  placeholder="请输入托售服务费"></el-input-number> %						
					</el-form-item>
					<div class="color-danger MT20 redText">
						注意：
						<p>1、托售自动结束时间最晚为候补结束时间</p>
					    <p>2、托售结束前手动关闭托售开关，已经委托给平台的历史托售订单不受影响</p>
						<p>3、当票品状态从候补变更为非候补时会自动关闭托售</p>
					</div>
				</el-form>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    status:'',
    ticketId:'',
	consignServiceFee:11,
	isAutoOpenConsign:1
}
export default {
    props:{
        activityId:{
            type:[Number,String],
            default:''
        },		
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultFormData
            },            
            itemData: null,
			itemTime:''
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultFormData
            }
        },
        show(itemData,time){			
            this.itemData = itemData;
			this.itemTime = time ? time : itemData.time;
            this.formDatas.ticketId = itemData.id; 
			this.formDatas.status = itemData.isOpenConsign;
			this.formDatas.consignServiceFee = itemData.consignServiceFee
			this.formDatas.isAutoOpenConsign = itemData.isAutoOpenConsign
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {			
			this.$confirm('操作托售开关，请先仔细阅读开启托售注意事项，再确认操作。', '提示', {
				// type: 'success',
				center: true,
				confirmButtonText:'确认提交',
				cancelButtonText:'取消',
				closeOnClickModal: false
			}).then(() => {
				this.$refs["formDatas"].validate((valid) => {
					if (valid) {
						this.btnLoading = true;    
						this.$request({
							url: '/activity/openConsign', ///activity/openConsign
							data: {
								...this.formDatas,
								activityId: this.activityId
							},
							method: "post",
						})
							.then((res) => {
								const { state, msg } = res.data;
								if (state == 1) {
									this.$emit("onUpdate");
									this.close();
								} else {
									this.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								self.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.btnLoading = false;
							});   
					} else {
						return false;
					}
				});
			}).catch(() => {
				
			})
        },
    }
}
</script>
<style lang="scss" scoped>
.houbulink{
	line-height: 24px;
	height: 24px;
}
.el-link.el-link--default{
	color:#409EFF;
	margin: -6px 0 0 10px;
}
.formBox{
	margin-top: 20px;
	
}
.redText{
	font-size: 12px;
	line-height: 24px;
}
.card1{
	font-size: 14px;
}
.item{
    margin-bottom: 20px;
}
.mark{
	font-size: 12px;
	line-height: 24px;
}
</style>